import { SelectionModel } from '@angular/cdk/collections';
import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { Constants } from '@app/shared/class/constants.class';
import { AppConfig } from '@config/app.config';
import { ChannelsService } from '@core/services/channels.service';
import { GeneralsService } from '@core/services/generals.service';
import { StatusService } from '@core/services/status.service';
import { ChannelsEditComponent } from '@modules/channels/channels-edit/channels-edit.component';
import { Channel } from '@shared/interfaces/channel';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-channels-list',
  templateUrl: './channels-list.component.html'
})
export class ChannelsListComponent implements OnInit, OnDestroy {
  public constants = new Constants();

  public location = 'channels';
  public channelsList: Array<Channel> = [];
  public channel: Channel;
  public dataSource: MatTableDataSource<Channel>;
  public selection = new SelectionModel<Channel>(true, []);

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('filter') filterInput: ElementRef;

  constructor(
    public appConfig: AppConfig,
    public generalsService: GeneralsService,
    public channelsService: ChannelsService,
    public statusService: StatusService
  ) {
    this.constants.displayedColumns = [
      this.appConfig.ACTIONS.delete.id,
      'id',
      'name',
      'status',
      this.appConfig.ACTIONS.edit.id
    ];
  }

  ngOnInit() {
    this.generalsService.action$
      .pipe(takeUntil(this.constants.destroy$))
      .subscribe((result: any) => {
        if (result) {
          const actions = this.generalsService.getActions(
            this.constants.displayedColumns,
            this.constants.actionsList,
            this.location
          );
          this.constants.displayedColumns = actions.displayedColumns;
          this.constants.displayedActions = actions.displayedActions;
          this.loadData();
        }
      });
  }

  ngOnDestroy() {
    this.constants.destroy$.next(true);
    this.constants.destroy$.unsubscribe();
  }

  loadData() {
    this.constants.loading = true;
    this.constants.elements = true;
    this.channelsService
      .getItems()
      .pipe(takeUntil(this.constants.destroy$))
      .subscribe(
        result => {
          this.channelsList = [];
          result.data.forEach((element: any) => {
            this.channel = {
              id: element.id,
              name: element.attributes.name,
              idStatus: element.relationships.status.id,
              status: element.relationships.status.name
            };
            this.channelsList.push(this.channel);
          });
          if (this.channelsList.length) {
            this.dataSource = new MatTableDataSource(this.channelsList);
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
            this.constants.filter = this.dataSource.filteredData;
            this.selection.clear();
          } else {
            this.constants.elements = false;
          }

          this.constants.error = false;
          this.constants.loading = false;
        },
        error => {
          this.constants.errorText = this.generalsService.showError(error);
          this.constants.error = true;
          this.constants.loading = false;
        }
      );
  }

  reload() {
    this.generalsService.reload(this);
  }

  edit(action: string, item?: Channel) {
    let dialog: any;

    const data = {
      action: action,
      item: {},
      relationships: {}
    };

    const loading = this.generalsService.loading();
    this.statusService
      .getItems()
      .pipe(takeUntil(this.constants.destroy$))
      .subscribe(
        result => {
          let res = false;
          loading.close();
          if (!result.data || result.data.length <= 0) {
            res = true;
          }

          if (action === this.appConfig.ACTIONS.add.id && res) {
            this.generalsService.notification(
              this.appConfig.NOTIFICATION.error,
              this.appConfig.LANG.amlLimits.noSegments
            );
          } else {
            if (action === this.appConfig.ACTIONS.add.id) {
              this.constants.message = this.appConfig.LANG.message.addSuccess;
            } else {
              data.item = item;
              this.constants.message = this.appConfig.LANG.message.editSuccess;
            }

            data.relationships = result.data;
            dialog = this.generalsService.modal(ChannelsEditComponent, data);

            dialog
              .afterClosed()
              .pipe(takeUntil(this.constants.destroy$))
              .subscribe((afterClosedResult: any) => {
                this.generalsService.afterClosed(
                  this,
                  afterClosedResult,
                  this.constants.message
                );
              });
          }
        },
        error => {
          loading.close();
          this.generalsService.notification(
            this.appConfig.NOTIFICATION.error,
            this.generalsService.showError(error)
          );
        }
      );
  }

  selectDelete() {
    const numSelected = this.selection.selected.length,
      numRows = this.dataSource.data.length;

    this.constants.labelDelete = this.generalsService.messageSelectedDelete(
      'label',
      numSelected,
      numRows
    );
  }

  filterData(event: any) {
    this.generalsService.applyFilter(this.dataSource, event);
    this.constants.filter = this.dataSource.filteredData;
  }
}
